import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateSelectionService {
  private _selectedDate = signal<Date | null>(null);
  selectedDate = this._selectedDate.asReadonly();

  set(date: Date | string) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    this._selectedDate.set(d);
  }

  dayRange = computed(() => {
    const d = this.selectedDate();
    if (!d) return null;
    const start = new Date(d);
    const end = new Date(d);
    end.setDate(end.getDate() + 1);
    return { start, end };
  });
}
